/**
 * The fallback icon for a report whose schema does not define its own `icon`
 * yet. Each report owns its icon in its schema (schemas/<report>.js); this is
 * the only shared icon that remains.
 *
 * Value is the inner SVG of a 24x24 tabler-style outline icon; the consuming
 * component supplies the <svg> wrapper and sizing.
 */
export const DEFAULT_REPORT_ICON =
    '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>'
    + '<path d="M14 3v4a1 1 0 0 0 1 1h4" />'
    + '<path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />'
    + '<path d="M9 17h6" />'
    + '<path d="M9 13h6" />'
